export default __webpack_public_path__ + "static/media/ELEMENTOS_19.7cfd527b.png";